module.exports = __webpack_public_path__ + "static/media/telecom1.2fffe3b2.jpg";